import React from 'react';
import IndexedSearchList from '../components/indexed-search-list';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const IndexedSearchesPage = () => (
  <Layout>
    <div className="page">
      <PageHeader
        title="Recherches indexées"
        description="Créer, éditer ou supprimer des recherches indexées."
      />

      {/* <div className="page_actions">
        <LinkButton
          className="page_action-button"
          icon="add"
          label="Créer une recherche indexée"
          to="/recherches-indexees/creer"
          theme="success"
        />
      </div> */}

      <div className="page_actions">
        <LinkButton
          className="page_action-button"
          icon="add"
          label="Créer des recherches indexées"
          to="/recherches-indexees/importer"
          theme="success"
        />
      </div>

      <IndexedSearchList />
    </div>
  </Layout >
);

export default IndexedSearchesPage;
